import React, { useEffect } from 'react';
import { Badge, Tooltip } from 'antd';
import { BellFilled } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'model';
import { getUnreadCount } from 'model/approval';
import classNames from 'classnames';
import style from './index.module.scss';
import tracker from 'lib/tracker';

interface Props {
  onClick?: (e: any) => void;
}

const ApprovalCenter: React.FC<Props> = ({ onClick }) => {
  const dispatch = useDispatch();
  const unReadCount = useSelector<RootState, number>((state) => state.approval.unReadCount);

  async function fetchUnreadApprovalMeeting() {
    dispatch(getUnreadCount());
  }

  useEffect(() => {
    fetchUnreadApprovalMeeting();
  }, []);

  const onClickApproval = () => {
    onClick && onClick();
    tracker?.reporteWebMenuView('审批中心');
  };

  const bellIconCls = classNames({
    [style.margin_right_4]: unReadCount >= 10 && unReadCount < 100,
    [style.margin_right_8]: unReadCount >= 100
  });

  return (
    <Badge offset={[-4, 1]} className={style.bell_icon} count={unReadCount} overflowCount={99} size="small">
      <Tooltip placement="bottom" title="审批中心" color="white" overlayInnerStyle={{ color: 'rgba(0, 0, 0, 0.85)' }}>
        <BellFilled
          onClick={onClickApproval}
          style={{
            color: '#999',
            fontSize: '20px',
            paddingTop: '2px'
          }}
          className={bellIconCls}
        />
      </Tooltip>
    </Badge>
  );
};

export default ApprovalCenter;
